var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    className: "create-feedback__icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.343 36v-5.834h5.686v-4.302h-5.687V20h-4.596v5.864H20v4.302h5.746V36h4.597Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.411 30.466 10.84) scale(93.4169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#A337F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A7ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFeedback);
export default __webpack_public_path__ + "static/media/create-feedback.623834002f742523f0abe7dc03b61b99.svg";
export { ForwardRef as ReactComponent };